package com.rosario.juridico.platform

import kotlinx.datetime.*

actual fun agregarEventoCalendario(titulo: String, fechaMillis: Long, descripcion: String) {
    // Para la web (JS), abrimos el editor de Google Calendar en una nueva pestaña
    val url = "https://calendar.google.com/calendar/r/eventedit?text=$titulo&details=$descripcion"
    openUrl(url)
}

actual fun localDateToMillis(fecha: LocalDate): Long {
    val tz = try {
        TimeZone.of("America/Argentina/Buenos_Aires")
    } catch (e: Exception) {
        TimeZone.of("UTC-3")
    }
    return fecha.atStartOfDayIn(tz).toEpochMilliseconds()
}

// Helper para abrir URLs en JS
private fun openUrl(url: String) {
    kotlinx.browser.window.open(url, "_blank")
}
